import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
})
export class ImagePreviewComponent implements OnInit {
  // Check if the passed data contains an array of images or a single image
  isMultipleImages: boolean;

  constructor(
    public dialogRef: MatDialogRef<ImagePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string | string[] }
  ) {}

  ngOnInit(): void {
    // Check if the data is an array or a single image
    this.isMultipleImages = Array.isArray(this.data.imageUrl);
  }
}
